export function usePortal(elementId: string): Element | null {
  return document.querySelector(`#${elementId}`);
}
